import global_axios from '../../funciones_globales/interaccionapi';
import { CARGAR_FACTURAS_PENDIENTESGUIAREMISION, CARGAR_GUIAREMISION } from './actionTypes';
import { VISUALIZAR_LOADING, VISUALIZAR_ALERTA } from '../generales/actionTypes';

export const cargar_FacturasPendientesGuiaRemisionPorCliente = (idCliente) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url: '/clientes/' + idCliente + '/facturas?PendienteGuiaRemision=S',
			method: 'GET'
		})
		.then( response => {
			let facturas = response.data;
			dispatch({
				type: CARGAR_FACTURAS_PENDIENTESGUIAREMISION,
				data: facturas
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});	
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar facturas', mensaje: msgError}
			});
		});
	}
}

export const cargar_GuiaRemision = (idGuiaRemision) => {
	return (dispatch) => {
		dispatch({
			type: VISUALIZAR_LOADING,
			isVisibleLoading: true
		});
		return global_axios({
			url: '/guiasremision/' + idGuiaRemision,
			method: 'GET'
		})
		.then( response => {
			let guiaRemision = response.data;
			dispatch({
				type: CARGAR_GUIAREMISION,
				data: guiaRemision
			});
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});	
		})
		.catch(error=>{
			let msgError = error.response?error.response.data.msg:error.message;
			dispatch({
				type: VISUALIZAR_LOADING,
				isVisibleLoading: false
			});
			dispatch({
				type: VISUALIZAR_ALERTA,
				data: {isVisible: true, tipo: 'error', titulo: 'Error al cargar guía de remisión', mensaje: msgError}
			});
		});
	}
}